export default __webpack_public_path__ + "static/media/Doribac-500-eng.996973c7.jpg";